<template>
  <div>
    <b-overlay :show="homeLoading" class="rounded" variant="transparent">
      <template #overlay>
        <b-img
          width="100"
          :src="require('@/assets/img/brand/loader.gif')"
          alt=""
        />
      </template>
      <b-row>
        <b-col md="2">
          <b-form-select
            v-model="filter.per_page"
            :options="[5, 10, 20, 100]"
            size="sm"
            class="mt-2"
            @input="debouncedGetAnswer()"
          ></b-form-select>
        </b-col>
        <b-col class="ml-auto col-sm-12 col-md-6 col-lg-6 mb-3">
          <b-form-group>
            <b-form-input
              class="form-control-sm"
              id="filter-input"
              v-model="filter.search"
              type="search"
              :placeholder="$t('search')"
              @input="debouncedGetAnswer()"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="12" class="table-responsive">
          <b-table
            class="align-items-center table-flush tablesorter table-text"
            hover
            :items="dataStadistic.data"
            :fields="columns"
            :per-page="filter.per_page"
            :current-page="filter.current_page"
            :busy="
              !Array.isArray(dataStadistic.data) ||
              dataStadistic.data.length === 0
                ? true
                : false
            "
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <span class="h2 text-danger">{{ $t("fail") }}</span>
              </div>
            </template>

            <template v-slot:cell(created_at)="data">
              {{ moment(data.item.created_at).format("DD-MM-YYYY HH:mm") }}
              hrs.
            </template>

            <!-- <template v-slot:cell(type)="data">
              <span v-if="data.item.type === 'super_admin'">{{$t("add-by-m2m")}}</span>
              <span v-if="data.item.type === 'matched_interest'">{{$t("referrals-between-users")}}</span>
            </template> -->
          </b-table>
          <b-pagination
            class="mt-3"
            v-model="filter.page"
            :total-rows="dataStadistic.total"
            :per-page="dataStadistic.per_page"
            :page-count="dataStadistic.per_page"
            @input="changePage"
            first-number
            pills
            size="sm"
            align="center"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
export default {

  async created() {
    await this.loadData();
    this.debouncedGetAnswer = _.debounce(this.loadData, 200);
  },

  data() {
    return {
      filter: {
        page: 1,
        per_page: 5,
        search: null,
      },
      moment,
    };
  },
  methods: {
    ...mapActions({
      fetchPointsGeneratedTable: "home/fetchPointsGeneratedTable",
    }),
    async loadData() {
      const payload = {
        page: this.filter.page,
        per_page: this.filter.per_page,
        search: this.filter.search
      }
      await this.fetchPointsGeneratedTable(payload);
    },
    async changePage(value) {
      this.filter.page = value;
      await this.debouncedGetAnswer();
    },
  },

  computed: {
    ...mapGetters({
      dataStadistic: "home/getPointsGeneratedTable",
      homeLoading: "home/homeLoading",
    }),
    columns() {
      return [
        { label: this.$t("amount"), key: "amount", class: "text-center" },
        { label: this.$t("concept"), key: "concept", class: "text-center" },
        { label: this.$t("type"), key: "type", class: "text-center" },
        { label: this.$t("date"), key: "created_at", class: "text-center" },
      ];
    },
  },
};
</script>
<style scoped>
.dropdown-menu .dropdown-menu-right {
  position: relative !important;
}
</style>
